import { atom } from 'recoil';

export const permissions = atom({
  key: 'permissions',
  default: 0,
});
